var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.headerBarFixed)?_c('a-layout-header',{class:[
		_vm.fixedHeader && 'ant-header-fixedHeader',
		_vm.sidebarOpened ? 'ant-header-side-opened' : 'ant-header-side-closed',
		'rs-header' ],style:({ padding: '0' })},[(_vm.mode === 'sidemenu')?_c('div',{staticClass:"header"},[_c('a-icon',{staticClass:"trigger",attrs:{"type":_vm.collapsed ? 'menu-unfold' : 'menu-fold'},on:{"click":_vm.toggle}}),_c('user-menu')],1):_vm._e()]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }